<wl-registration-custom-reg-field
  [customField]="fieldAndResponse.customField"
  [response]="fieldAndResponse.response"
  (responseChange)="onResponseChange($event)"
  *ngFor="let fieldAndResponse of customFieldsAndResponses"
></wl-registration-custom-reg-field>
